import { render, staticRenderFns } from "./PurchaseWaitReceive.vue?vue&type=template&id=10b62bba&"
import script from "./PurchaseWaitReceive.vue?vue&type=script&lang=js&"
export * from "./PurchaseWaitReceive.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseWaitReceive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports